var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"tab-pane"},_vm._l((_vm.tabs),function(item,index){return _c('el-tag',{key:item._id,staticClass:"tag",attrs:{"size":"small","type":item.checked ? '' : 'info'},on:{"click":function($event){return _vm.onSelectTag(index)}}},[_vm._v(_vm._s(item.name))])}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }